import { Box, FormControl } from '@mui/material'
import { ReactElement, useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import SearchAndMultiSelectInput from '../../Common/SearchAndMultiSelectInput'
import { fetchAvaliblePrograms } from '../../../services/programServices'

export interface IProgramColumnFilter {
    id: string
    label: string
    value: any
    onChange: any
    templateId: string
    orgId: string
}

export const ProgramColumnFilter = (
    props: IProgramColumnFilter,
): ReactElement => {
    const { id, label, value, onChange, templateId, orgId } = props

    const [Programs, setPrograms] = useState<{ id: string; name: string }[]>([])
    const [selectedValues, setSelectedValues] = useState<string[]>([])

    const { t } = useTranslation()

    const onChangeRecord = useCallback(
        (id: string, selectedList: any[]) => {
            setSelectedValues(selectedList)
            onChange(id, selectedList)
        },
        [onChange],
    )

    const onSelectRecords = useCallback(
        (id: string, items: any) => {
            onChangeRecord(id, items)
        },
        [onChangeRecord],
    )

    useEffect(() => {
        setSelectedValues(value)
    }, [value])

    useEffect(() => {
        if (templateId && orgId) {
            const getRecords = async () => {
                try {
                    const availableProgramsList =
                        await fetchAvaliblePrograms(orgId)
                    const updatedProgramsList = availableProgramsList.map(
                        (p) => {
                            return { id: p.programId, name: p.programName }
                        },
                    )
                    const noProgram = { id: 'noProgram', name: 'No Program' }
                    updatedProgramsList.unshift(noProgram)
                    setPrograms(updatedProgramsList)
                } catch (e) {
                    console.log(e)
                }
            }
            getRecords()
        }
    }, [templateId, orgId])

    return (
        <Box>
            <FormControl fullWidth size="small">
                <Box sx={{ display: 'flex', alignItems: 'flex-start' }}>
                    <Box
                        sx={{
                            width: '100%',
                            maxWidth: `100%`,
                        }}
                    >
                        <SearchAndMultiSelectInput
                            id={id}
                            label={label}
                            placeholder={t('selectLabel', { label })}
                            value={selectedValues}
                            list={Programs}
                            onSelect={onSelectRecords}
                            autoFocusOnMount={true}
                            showLabel={false}
                            stopKeyboardPropagation={true}
                        />
                    </Box>
                </Box>
            </FormControl>
        </Box>
    )
}
